import watch from 'redux-watch';

class MapToCoordinatesPointerCtrl {

    constructor($scope, storeServ, mapServ, mapHelperServ) {
        this.$scope = $scope;
        this.storeServ = storeServ;
        this.mapServ = mapServ;
        this.mapHelperServ = mapHelperServ;

        this.ngOnInit();
    }

    ngOnInit() {
        this.subscribeToStore();

        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    subscribeToStore() {
        let watchSearchedPlaceCoordinates = watch(this.storeServ.getState, 'searchedPlaceCoordinates');
        let watchPointMapToCoordinates = watch(this.storeServ.getState, 'pointMapToCoordinates');

        this.stopWatchingSearchedPlaceCoordinates = this.storeServ.subscribe(watchSearchedPlaceCoordinates((newCoordinates, oldCoordinates, objectPath) => {
            if (newCoordinates) {
                this.pointMap(newCoordinates.location, newCoordinates.viewport);
            }
        }));

        this.stopWatchingPointMapToCoordinates = this.storeServ.subscribe(watchPointMapToCoordinates((newCoordinates, oldCoordinates, objectPath) => {
            if (newCoordinates) {
                this.pointMap(newCoordinates.location, newCoordinates.viewport);
            }
        }));
    }

    pointMap(location, viewport) {
        if (viewport) {
            this.map.fitBounds(new google.maps.LatLngBounds(
                new google.maps.LatLng(viewport.southWestLat, viewport.southWestLng),
                new google.maps.LatLng(viewport.northEastLat, viewport.northEastLng)
            ));
        } else {
            this.map.setCenter(this.mapHelperServ.getLatLng(location.lat, location.lng));
            this.map.setZoom(this.mapServ.getZoomWhenTheMapIsPointedToCoordinates());
        }
    }

    ngOnDestroy() {
        this.stopWatchingSearchedPlaceCoordinates();
        this.stopWatchingPointMapToCoordinates();
    }
}

MapToCoordinatesPointerCtrl.$inject = ['$scope', 'storeServ', 'mapServ', 'mapHelperServ'];

var mapToCoordinatesPointerComponent = function() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        controller: MapToCoordinatesPointerCtrl,
        bindToController: {
        	map: '='
        }
    };
};

export default mapToCoordinatesPointerComponent;